module.exports = __webpack_public_path__ + "static/fonts/Gotham-Black.89aec2c.otf";


//////////////////
// WEBPACK FOOTER
// ./src/formats/font/Gotham-Black.otf
// module id = I2R9
// module chunks = 1